var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sold-out",class:{ 'sold-out--corner': _vm.corner }},[_c('div',[_vm._v("Sold Out")])])}
var staticRenderFns = []

export { render, staticRenderFns }